import { ResponsiveModalOrBottomSheet } from 'src/components/ResponsiveModalOrBottomSheet/ResponsiveModalOrBottomSheet'
import { CuiLink } from 'front-lib'
import { useAtom } from 'jotai'
import { downloadCalendarModalAtom } from 'src/atoms/modals/downloadCalendarModal.atom'
import { useExclusiveModal } from 'src/hooks/useExclusiveModalAtom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useGetUserCalendar } from 'src/hooks/useGetUserCalendar'
import { useMemo } from 'react'
import { isIOSDevice, isMacOSDevice } from 'src/utils/utils'

import './SyncCalendarModal.scss'

export function SyncCalendarModal() {
  useExclusiveModal(userOnboardingModalAtom)

  const { data } = useGetUserCalendar()

  const [{ isOpen }, setDownloadCalendarModal] = useAtom(
    downloadCalendarModalAtom
  )

  const calendarUrl = useMemo(() => {
    if (!data?.calendarS3Url) {
      return ''
    }

    if ((isIOSDevice() || isMacOSDevice()) && !!data?.calendarS3Url) {
      return data.calendarS3Url.replace('https://', 'webcal://')
    }
    return data?.calendarS3Url
  }, [data])

  function handleClose() {
    setDownloadCalendarModal({ isOpen: false })
  }

  return (
    <ResponsiveModalOrBottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      className="download-calendar-modal">
      <h2>Connect your calendar</h2>
      <p>Tap below to sync your CookUnity calendar.</p>
      <CuiLink href={calendarUrl} target="_blank" onClick={handleClose}>
        Let's go!
      </CuiLink>
    </ResponsiveModalOrBottomSheet>
  )
}
